var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.610056,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.610056,
    y: 1.03291,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    stroke: "#E2E2EA",
    strokeWidth: 0.659565
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_661_20216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8193 8.39453V10.2083",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6582 8.39453V10.2083",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79688 11.939C8.79688 10.482 9.97806 9.30078 11.4351 9.30078H17.0414C18.4985 9.30078 19.6797 10.482 19.6797 11.939V17.8476C19.6797 19.3047 18.4985 20.4859 17.0414 20.4859H11.4351C9.97807 20.4859 8.79688 19.3047 8.79688 17.8476V11.939Z",
    stroke: "#A461D8",
    strokeWidth: 0.989347
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4248 16.2522L13.4435 17.0671C13.7191 17.2876 14.1195 17.252 14.3519 16.9864L16.0524 15.043",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79688 12.625H19.6797",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_661_20216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5104,
    height: 14.5104,
    fill: "white",
    transform: "translate(6.9834 7.18359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderDark);
export default __webpack_public_path__ + "static/media/calender-dark.11fe4b3aafad55562be85acad2a1e315.svg";
export { ForwardRef as ReactComponent };